export enum StoreStatus {
  BUSY = "busy",
  IDLE = "idle",
  ERROR = "error",
}
